import * as React from "react";
import Loader from "../../../components/atoms/Loader";
import TabsNavi from "../../../components/molecules/TabsNavi";
import StudentTag from "../../../domains/StudentTag";
import OperatorInterface from "../../../interfaces/OperatorInterface";
import SectionInterface from "../../../interfaces/SectionInterface";
import {
  ActiveOperator,
  Invitation,
} from "../../../interfaces/SectionOperatorsInterface";
import ActiveOperatorList from "./ActiveOperatorList";
import InviteOperatorForm from "./InviteOperatorForm";
import InvitingOperatorList from "./InvitingOperatorList";

interface Props {
  section: SectionInterface;
  currentOperator: OperatorInterface;
  sectionTags: StudentTag[];
  isLoading: boolean;
  activeOperators: ActiveOperator[] | undefined;
  invitingOperators: Invitation[] | undefined;
}

const SectionsSettingsOperators = (props: Props) => {
  return (
    <React.Fragment>
      <TabsNavi
        tabs={[
          {
            label: "スタッフ",
            link: `#`,
            active: true,
          },
        ]}
      />
      <InviteOperatorForm sectionId={props.section.id} />
      <InvitingOperatorList
        sectionId={props.section.id}
        sectionName={props.section.sectionName}
        invitingOperators={props.invitingOperators || []}
      />
      <ActiveOperatorList
        section={props.section}
        sectionTags={props.sectionTags}
        currentOperator={props.currentOperator}
        activeOperators={props.activeOperators || []}
      />
      <Loader loading={props.isLoading} />
    </React.Fragment>
  );
};

export default SectionsSettingsOperators;
